<template>
    <div v-if="loading">
        <div
            class="w-16 h-16 rounded-full animate-spin border-4 border-solid border-primary-500 border-t-transparent"
        ></div>
    </div>
    <div v-if="services.length">
        {{ services }}
    </div>
</template>
<script>
export default {
    name: "MultistepReturnServices",
    props: {
        loading: Boolean,
        services: Array,
    },
};
</script>